import { IntlProvider } from 'react-intl';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import * as Toast from '@givebutter/primitives/toast';
import { Portal } from '@radix-ui/react-portal';
import App from 'assets/js/App';
import { SentryErrorBoundary } from 'components/error-boundaries/SentryErrorBoundary';
import { TooltipProvider } from 'components/tooltip';
import { GlobalStyle } from 'helpers/global-style';
import { ThemeProvider } from 'providers/ThemeProvider';
import { queryClient } from 'queries/queryClient';

const Root = ({ children = <App /> }) => {
    return (
        <SentryErrorBoundary>
            <ThemeProvider>
                <IntlProvider locale="en" defaultLocale="en">
                    <GlobalStyle />
                    <QueryClientProvider client={queryClient}>
                        <Toast.Provider swipeDirection={'up'}>
                            <TooltipProvider delayDuration={0}>
                                {children}
                                <ReactQueryDevtools initialIsOpen={false} />
                            </TooltipProvider>
                            <Portal>
                                <Toast.Queue />
                                <Toast.Viewport />
                            </Portal>
                        </Toast.Provider>
                    </QueryClientProvider>
                </IntlProvider>
            </ThemeProvider>
        </SentryErrorBoundary>
    );
};

export default Root;
